import { COLORS } from '@shared/config/colors/colors';
import { mainFonts } from '@shared/ui/typography/tokens';

const HEADINGS: Array<keyof typeof mainFonts> = ['h1', 'h2', 'h3', 'h4', 'h4', 'h5', 'h6'];

export const productDescriptiobQuillStyle = () => `
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: ${COLORS.neutral_90};

    ${HEADINGS.map(
        (heading) => `
        ${heading} {
            font-size: ${mainFonts[heading].size};
            font-weight: ${mainFonts[heading].weight};
            line-height: ${mainFonts[heading].lineHeight};
        }
    `
    ).join('\n')}
`;
